import React, { useState } from "react";
import { Mutation } from "react-apollo";
import BasicInformation from "./basic-information";
import IndicatorSubItem from "./indicator-subitem";
import gql from "graphql-tag";
import {
	withStyles,
	Stepper,
	Step,
	StepLabel,
	StepContent,
	Typography,
	Button,
	Paper,
	Fab
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import AnalyticalConfiguration from "./analytical-configuration";
import BackIcon from "@material-ui/icons/ArrowBack";

const styles = (theme) => ({
	root: {
		width: "100%"
	},
	button: {
		marginTop: 8,
		marginRight: 1
	},
	actionsContainer: {
		marginBottom: 2
	},
	resetContainer: {
		padding: 3
	},
	title: {
		textAlign: "center",
		padding: 16
	},
	saveButton: {
		marginLeft: 24,
		marginBottom: 24
	},
	paper: {
		position: "relative"
	},
	fab: {
		position: "absolute",
		top: 0,
		right: 0,
		transform: `translateX(${-50}%) translateY(${50}%)`
	}
});

const ADD_INDICATOR = gql`
	mutation($indicator: IndicatorInput!) {
		addIndicator(indicator: $indicator) {
			id
			name
			description
			paletteType
			generalities {
				description
				files {
					name
					id
				}
			}
			inequalities {
				description
				files {
					name
					id
				}
			}
			tags {
				_id
				name
				description
			}
			deleted
			stratifiers {
				id
				name
				order
			}
			demographicVariable
			order
		}
	}
`;

const GET_INDICATORS = gql`
	{
		allIndicators {
			_id
			name
			description
			paletteType
			deleted
		}
	}
`;

//Títulos para cada Stepper
function getSteps() {
	return [
		"Información básica",
		"Generalidades",
		"Desigualdades",
		"Configuración analítica"
	];
}

//Retorna el contenido según el step
function getStepContent(step, addItem, indicator) {
	switch (step) {
		case 0:
			return (
				<BasicInformation
					indicatorId={null}
					indicator={indicator}
					onSubmit={addItem}
					title={false}
				/>
			);
		case 1:
			return (
				<IndicatorSubItem
					indicatorId={null}
					subItemKey="generalities"
					subItemTitle="Generalidades"
					indicator={indicator}
					onSubmit={addItem}
					title={false}
				/>
			);
		case 2:
			return (
				<IndicatorSubItem
					indicatorId={null}
					subItemKey="inequalities"
					subItemTitle="Desigualdades"
					indicator={indicator}
					onSubmit={addItem}
					title={false}
				/>
			);
		case 3:
			return (
				<AnalyticalConfiguration
					indicatorId={null}
					indicator={indicator}
					onSubmit={addItem}
				/>
			);
		default:
			return "Unknown step";
	}
}

/**
 * Componente para agregar indicadores
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0
 */
const AddIndicator = ({ classes, history, ...rest }) => {
	const [activeStep, setActiveStep] = useState(0);
	const [indicator, setIndicator] = useState(null);
	const steps = getSteps();

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const redirect = () => {
		history.push("/admin/indicators/");
	};

	const addItem = async (data) => {
		setIndicator(data.variables.indicator);
		handleNext();
	};

	return (
		<Mutation
			mutation={ADD_INDICATOR}
			variables={{ indicator }}
			onCompleted={redirect}
			update={(cache, { data: { addIndicator } }) => {
				const { allIndicators } = cache.readQuery({ query: GET_INDICATORS });
				cache.writeQuery({
					query: GET_INDICATORS,
					data: { allIndicators: { ...allIndicators, addIndicator } }
				});
			}}
		>
			{(save) => {
				return (
					<div className={classes.root}>
						<Paper className={classes.paper}>
							<Fab
								className={classes.fab}
								color={"primary"}
								onClick={() => null}
							>
								<BackIcon onClick={() => history.push("/admin/indicators")} />
							</Fab>
							<div className={classes.title}>
								<Typography variant="h5">Agregar indicador</Typography>
							</div>
							<Stepper activeStep={activeStep} orientation="vertical">
								{steps.map((label, index) => (
									<Step key={label}>
										<StepLabel>{label}</StepLabel>
										<StepContent>
											{getStepContent(index, addItem, indicator)}
											<div className={classes.actionsContainer}>
												<Button
													disabled={activeStep === 0}
													variant="contained"
													color="primary"
													onClick={handleNext}
													className={classes.button}
												>
													Siguiente
												</Button>
											</div>
										</StepContent>
									</Step>
								))}
							</Stepper>
							<div>
								<Button
									disabled={activeStep !== 4}
									variant="contained"
									color="primary"
									onClick={save}
									className={classes.saveButton}
								>
									Guardar indicador
								</Button>
							</div>
						</Paper>
					</div>
				);
			}}
		</Mutation>
	);
};

AddIndicator.propTypes = {
	classes: PropTypes.object,
	history: PropTypes.object
};

export default withRouter(withStyles(styles)(AddIndicator));



// WEBPACK FOOTER //
// ./src/components/admin/indicators/addIndicator.js